import { render } from "./CenteredContent.vue?vue&type=template&id=06bc1bf0"
import script from "./CenteredContent.vue?vue&type=script&lang=js"
export * from "./CenteredContent.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__